import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/socials/black/behance.svg")